<template>
  <div>    
    <InstantGolfRounds v-if="golfItems.length > 0" />
  </div>
</template>

<script>
import InstantGolfRounds from "../components/InstantGolfRounds";
export default {
  name: "InstantQuote",
  components: {
    InstantGolfRounds,
  },
  computed: {
    golfItems() {
      return this.$store.state.instantQuote.golfItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.labelsMail{
font-family: "Roboto", sans-serif !important;
  color: black !important;
}
.emailh4{
  font-family: "Roboto", sans-serif !important;
  color: black !important;
  font-weight: bold !important;
}
.fas{
  position: relative !important ;
  color: red !important;
}

.reservationBtn{
    width: 95% !important;
    height: 50px !important;
    margin-bottom: 16px !important;
    background: #5E4896 !important;
    color: #FF9600 !important;
    border-radius: 10px !important;
    font-size: 20px !important;
    
}
.btnOnBootom{
  cursor: default !important;
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
  margin-left: 2px !important;
  border: 3px solid #5E4896 !important;
  border-bottom: none !important;
  height: 168px  !important;

}
.errAlert{
    color: red !important ;
    padding: 0 !important ;
    margin-top: 10px !important ;
}
.emailContent-holder{
  display: flex !important;
  flex-direction: column;
    @media screen and (max-width: 800px) {
       width: 100% !important;
    }
}
.emailPara{
  margin-right: 76px !important;
 @media screen and (max-width: 1600px) {
      display: block; 
    }
    @media screen and (max-width: 800px) {
       margin-right: 0px !important;

    }
}
.singleInput{
  margin-bottom: 24px !important;
    display: block !important;
  label{
    font-size: 20px !important;
  }
  input{
    font-size: 20px !important;
  }
  @media screen and (max-width: 800px) {
      display: flex !important; 
      justify-content: space-between;
    }
     @media screen and (max-width: 600px) {
      display: block !important; 
      justify-content: space-between;
    }
}
.email-promp-container{
    display: block !important;
    align-content: center !important;
    justify-content: center !important;
    width: 45% !important;
    height: 267px !important;
    margin-top: 350px !important;
     @media screen and (max-width: 1600px) {
       height: 300px !important;
    }
     @media screen and (max-width: 1200px) {
       width: 55% !important;
    }
     @media screen and (max-width: 800px) {
        height:485px  !important;
        margin-top: 250px !important;
    }
      @media screen and (max-width: 600px) {
        width: 60% !important;
        height:545px  !important;
      }
    }
    .promp-title{
        margin-top: 30px !important;
        @media screen and (max-width: 540px) {
            font-size: 18px !important;
            }
        .promp-question{
            font-size : 25px !important;
            font-weight: bolder !important;
            color: #FF9600 !important;
             @media screen and (max-width: 540px) {
            font-size: 18px !important;
            }
             @media screen and (max-width: 280px) {
            font-size: 18px !important;
            }
            
        }
    }
.email-btn-promp{
        display: flex !important;
        margin-left: 0px !important;
        align-content: center !important;
        justify-content: space-around !important;
        @media screen and (max-width: 800px) {
              display: block !important;
              margin-top: -30px !important;
              margin-left: 20px !important;
            }
        .onebtn{
            height: 55px !important;
            width: 230px !important;
            background-color: #5E4896 !important;       
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: #FFFFFF !important;
            font-size: 20px !important;
            letter-spacing: 0 !important;
            line-height: 25px !important;
            font-weight: bold !important;
            border-radius: 10px !important;
            border: none !important;
          @media screen and (max-width: 800px) {
              width: 95% !important;
              font-size: 12px !important;
              margin-left: 0px !important;
              margin-top: 20px !important;
            }
         
        }
    }
.email-inputs{
  margin-left: 74px !important;
  @media screen and (max-width: 1580px) {
              margin-left: 0px !important;

            }
}
.mediaForMobile{
   @media screen and (max-width: 800px) {
           margin-left: 45px !important;
           width: 100% !important;
            }
        @media screen and (max-width: 600px) {
              margin-left: 0px !important;

    }
}
.mediaForMobileFrist{
  @media screen and (max-width: 800px) {
           width: 100% !important;
           margin-left: 20px !important;
            }
              @media screen and (max-width: 600px) {
              margin-left: 0px !important;

    }
}
.mediaForMobileLast{
   @media screen and (max-width: 800px) {
           width: 100%;
            }
              @media screen and (max-width: 600px) {
              margin-left: 0px;

    }
}
.email-title{
  display: flex;
  justify-content: space-around;
       padding: 8px;
         @media screen and (max-width: 800px) {
            display: inline;
            }
        @media screen and (max-width: 540px) {
            font-size: 18px !important;
            margin-left: 30px !important;
            }
        .email-question{
            font-size : 20px !important;
            font-weight: bolder;
             @media screen and (max-width: 540px) {
            font-size: 18px !important;
            }
             @media screen and (max-width: 280px) {
            font-size: 18px !important;
            }
        }
    }
.email-sentWraper{
  display: flex !important;
    justify-content: space-between !important;
    margin-top: 20px !important;
}
.emain-container {
  display: flex !important;
  flex-wrap: wrap !important;
  border-bottom: 4px solid #5e4896 !important;
  // border-top: 2px solid #5e4896;
  .emailBtn{
    height: 65px !important;
    width: 388px !important;
    background-color:  #5e4896 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #FFFFFF !important;
    font-size: 20px !important;
    letter-spacing: 0 !important;
    line-height: 25px !important;
    font-weight: bold !important;
    border: none !important;
    border-top-left-radius: 30px !important;

    border-top-right-radius: 30px !important;
  }
  .emailBtn:hover{
    background-color: #FF9600 !important;
  }
  .bookNowBtn{
    height: 65px !important;
    width: 388px !important;
    background-color:  #5e4896 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #FFFFFF !important;
    font-size: 20px !important;
    letter-spacing: 0 !important;
    line-height: 25px !important;
    font-weight: bold !important;
    border: none !important;
    border-top-right-radius: 30px !important;
    margin-left: 1px !important;
    border-top-left-radius: 30px !important;
  }
  }
  .bookNowBtn:hover{
    background-color: #FF9600 !important;
  }
body{
  margin: 0px !important;
  padding: 0px !important;
}
.ultimateAwailable{
    font-size: 20px !important;
    color: #5e4896 !important;
    font-weight: bold !important;
    text-align: center !important;
}
.left{
margin-left: 18px !important;
}
.right{
    margin-right: 5px !important;
    @media screen and (max-width: 280px) {
      margin-left: 10px !important;
    }
    @media screen and (max-width: 540px) {
      margin-left: 10px !important;
    }
}
.promp-container1{
    display: block !important;
    box-sizing: content-box !important;
    align-content: center !important;
    justify-content: center !important;
    width: 45% !important;
    height: 200px !important;
    margin-top: 300px !important;
     @media screen and (max-width: 1200px) {
       width: 55% !important;
    }
    
      @media screen and (max-width: 600px) {
        width: 60% !important;
       
    }
    .promp-title{
        margin-top: 30px !important;
        // margin-left: 60px;
        @media screen and (max-width: 540px) {
            font-size: 18px !important;
            }
        .promp-question{
            font-size : 25px !important;
            font-weight: bolder !important;
            color: #FF9600 !important;
             @media screen and (max-width: 540px) {
            font-size: 18px !important;
            }
             @media screen and (max-width: 280px) {
            font-size: 18px !important;
            }
        }
    }
    .btn-promp{
        display: flex !important;
        margin-top: 30px !important;
        margin-left: 0px !important;
        align-content: center !important;
        // justify-content: space-between;

        .onebtn{
            height: 55px !important;
            width: 40% !important ;
            background-color: #5E4896 !important;       
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: #FFFFFF !important;
            font-size: 20px !important;
            letter-spacing: 0 !important;
            line-height: 25px !important;
            font-weight: bold !important;
            border-radius: 10px !important;
            border: none !important;
            margin-top: 20px !important;
          @media screen and (max-width: 600px) {
              font-size: 12px !important;
            width: 70% !important ;

              margin-left: 0px !important;
            }
            @media screen and (max-width: 280px) {
              // height: 38px;
              font-size: 12px;
              margin-left: 0px;
          }
        }
    }
}
.modalDialog1 {
    position: fixed !important;
    font-family: Arial, Helvetica, sans-serif !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    background: rgba(0, 0, 0, 0.8) !important;
    z-index: 1222 !important;
    opacity:1 !important;
    -webkit-transition: opacity 400ms ease-in !important;
    -moz-transition: opacity 400ms ease-in !important;
    transition: opacity 400ms ease-in !important;
    overflow: scroll !important;
    
}
.modalDialog1:target {
    opacity:1 !important;
    pointer-events: auto !important;
}
.modalDialog1 > div {
    width: 40% !important;
    position: relative !important;
    margin-bottom: 100px !important;
    margin:  auto ;
    padding: 5px 20px 13px 20px !important;
    border-radius: 10px !important;
    background: #fff !important;
    background: -moz-linear-gradient(#fff, #999) !important;
    background: -webkit-linear-gradient(#fff, #999 !important);
    background: -o-linear-gradient(#fff, #999) !important;
    
}   
.prompBox{
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
    margin-top: auto !important;
    background-color: gray !important;
}
.package-container {
  display: flex !important;
  flex-wrap: wrap !important;
  border-bottom: 4px solid #5e4896 !important;
  padding: 0 0px !important;
  width: 100% !important;
  .package-item1 {
    height: 156px !important;
    width: 288px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    @media screen and (max-width: 1250px) {
      width: 273px !important;
    }
    @media screen and (max-width: 1200px) {
      width: 240px !important;
    }
    @media screen and (max-width: 1070px) {
      width: 200px !important;
    }
    @media screen and (max-width: 900px) {
      width: calc(50% - 10px) !important;
      border: 1px solid #ccc !important;
      margin: 3px !important;
      border-bottom-right-radius: 10px !important;
      border-bottom-left-radius: 10px !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
    }
    @media screen and (max-width: 500px) {
      border-radius: 10px !important;
      width: 100% !important;
      border: 1px solid #ccc !important;
      margin: 10px !important;
    }
    &.active {
      border: 1px solid #5f4798 !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
      background:  #f4f2ff !important;
      border-bottom: 0 !important;
      @media screen and (max-width: 900px) {
        border: 1px solid #5f4798 !important;
        border-bottom-right-radius: 10px !important;
        border-bottom-left-radius: 10px !important;
      }

      @media screen and (max-width: 500px) {
        border: 1px solid #5f4798 !important;
      }
    }
    
    .text-center {
      text-align: center !important;
    }
    .package-title {
      color: #5e4896 !important;
      font-family: Roboto !important;
      font-size: 24px !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      text-align: center !important;
      margin-bottom: 11px !important;
      margin-top: 0 !important;
      @media screen and (max-width: 1250px) {
        font-size: 20px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 16px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 24px !important;
      }
    }
    .package-rounds {
      color: #5e4896 !important;
      font-family: Roboto !important;
      font-size: 18px !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      text-align: center !important;
      margin-top: 11px !important;
      margin-bottom: 0 !important;
      @media screen and (max-width: 1250px) {
        font-size: 14px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 12px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 18px !important;
      }
    }
    .package-price {
      color: #ff9600 !important;
      font-family: Roboto !important;
      font-size: 24px !important;
      font-weight: bold !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      margin: 0 !important;
      margin-top: 15px !important;
      @media screen and (max-width: 1250px) {
        font-size: 20px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 14px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 24px !important;
      }
    }
  }
}
.package-container {
  display: flex !important;
  flex-wrap: wrap !important;
  border-bottom: 4px solid #5e4896 !important;
  padding: 0 0px !important;
  .package-item {
    height: 131px !important;
    width: 288px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    @media screen and (max-width: 1250px) {
      width: 273px !important;
    }
    @media screen and (max-width: 1200px) {
      width: 240px !important;
    }
    @media screen and (max-width: 1070px) {
      width: 200px !important;
    }
    @media screen and (max-width: 900px) {
      width: calc(50% - 10px) !important;
      border: 1px solid #ccc !important;
      margin: 3px !important;
      border-bottom-right-radius: 10px !important;
      border-bottom-left-radius: 10px !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
    }
    @media screen and (max-width: 500px) {
      border-radius: 10px !important;
      width: 100% !important;
      border: 1px solid #ccc !important;
      margin: 10px !important;
    }
    &.active {
      border: 1px solid #5f4798 !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
      background:  #f4f2ff !important;
      border-bottom: 0 !important;
      @media screen and (max-width: 900px) {
        border: 1px solid #5f4798 !important;
        border-bottom-right-radius: 10px !important;
        border-bottom-left-radius: 10px !important;
      }

      @media screen and (max-width: 500px) {
        border: 1px solid #5f4798 !important;
      }
    }
    
    .text-center {
      text-align: center !important;
    }
    .package-title {
      color: #5e4896 !important;
      font-family: Roboto !important;
      font-size: 24px !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      text-align: center !important;
      margin-bottom: 11px !important;
      margin-top: 0 !important;
      @media screen and (max-width: 1250px) {
        font-size: 20px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 16px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 24px !important;
      }
    }
    .package-rounds {
      color: #5e4896 !important;
      font-family: Roboto !important;
      font-size: 18px !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      text-align: center !important;
      margin-top: 11px !important;
      margin-bottom: 0 !important;
      @media screen and (max-width: 1250px) {
        font-size: 14px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 12px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 18px !important;
      }
    }
    .package-price {
      color: #ff9600 !important;
      font-family: Roboto !important;
      font-size: 24px !important;
      font-weight: bold !important;
      letter-spacing: 0 !important;
      line-height: 18px !important;
      margin: 0 !important;
      margin-top: 15px !important;
      @media screen and (max-width: 1250px) {
        font-size: 20px !important;
      }
      @media screen and (max-width: 800px) {
        font-size: 14px !important;
      }
      @media screen and (max-width: 500px) {
        font-size: 24px !important;
      }
    }
  }
}
.selected-package {
  padding: 30px 40px !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-bottom: 2px solid #5e4896 !important;
  @media screen and (max-width: 900px) {
    justify-content: center !important;
  }
  .selected-title {
    color: #5e4896 !important;
    font-family: Roboto !important;
    font-size: 24px !important;
    font-weight: 500 !important;
    letter-spacing: 0 !important;
    line-height: 18px !important;
    @media screen and (max-width: 560px) {
      font-size: 20px !important;
    }
    @media screen and (max-width: 500px) {
      text-align: center !important;
    }
  }
  .selected-button {
    height: 65px !important;
    width: 388px !important;
    background-color: #ff9600 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #ffffff !important;
    font-size: 22px !important;
    letter-spacing: 0 !important;
    line-height: 25px !important;
    font-weight: bold !important;
    border-radius: 10px !important;
    border: none !important;
    @media screen and (max-width: 560px) {
      font-size: 20px !important;
    }
  }
}
</style>